/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';
import { toggleMfaGetResponseSchema } from './toggleMfaGetResponseSchema.ts';

/**
 * @description 200 response
 */
export const getToggleMfa200Schema = z.lazy(() => toggleMfaGetResponseSchema);

/**
 * @description 505 response
 */
export const getToggleMfa505Schema = z.any();

export const getToggleMfaQueryResponseSchema = z.lazy(() => getToggleMfa200Schema);
